import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Card';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "card"
    }}>{`Card`}</h1>
    <p>{`Extension of the Box component with card styles`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Card width={256}>
  <Image src={props.image} />
  <Heading>Card</Heading>
</Card>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      